// extracted by mini-css-extract-plugin
module.exports = {"load_wrapper":"Loader_load_wrapper__31T9g","lds_ring":"Loader_lds_ring__2bW_X","lds-ring":"Loader_lds-ring__BE2gU"};